"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _FullInternals_1 = require("./_FullInternals");
module.exports = _FullInternals_1.Konva;



//////////////////
// WEBPACK FOOTER
// ./node_modules/konva/lib/index.js
// module id = 737
// module chunks = 36